import React, { useState, useEffect, Fragment } from 'react';
import StyledContainer from '../../../../partials/StyledContainer'
import './VideoWrapper.scss';

const VideoWrapper = (props) => {

  const [visible, setVisible] = useState(props?.visible || false);
  const [optionsSelected, setOptionsSelected] = useState([]);
  const [singlequestionIndex, setSinglequestionIndex] = useState(0);

  const mapQuestions = () => {
    let questions = [];
    props.questions.forEach( (question, index) => {
      questions.push({ id: index, value: "" });
    });
    setOptionsSelected(questions);
  }

  const handleNextClick = (questionIndex) => {
    questionIndex = questionIndex+1;
    console.log("questionIndex" , questionIndex);
    console.log("props.questions.length" , props.questions.length);
    if(questionIndex < props.questions.length) {
      setSinglequestionIndex(questionIndex)
    }else{
      props.onAnswered()
    }
  }

  const updateItem =(id, whichvalue, newvalue)=> {
    var index = optionsSelected.findIndex(x=> x.id === id);
  
    let g = optionsSelected[index]
    g[whichvalue] = newvalue
    if (index === -1){
      // handle error
      console.log('no match');
    }
    else
      setOptionsSelected([
        ...optionsSelected.slice(0,index),
        g,
        ...optionsSelected.slice(index+1)
      ]);
  };

  const validateAnswer = (questionIndex) => {
      const answered = optionsSelected[questionIndex].value;
      const correct = props.questions[questionIndex].options[answered].correct;
      return correct;
  }

  useEffect(() => {
    if(props.hasQuestions && props.questions.length > 0) {
      mapQuestions();
    }
  }, []);

  return (
    <div className={`video-question-container`}>
      <div className={`video-wrapper ${visible ? '' : ''}`}>
        <video width="100%" controls id="video-player" autoPlay={true} onEnded={ () => { 
          if(props.hasQuestions) {
            props.onEnded();
            setVisible(false);
          }else{
            props.onEnded();
            setVisible(true);
          }
        }}>
          <source src={props.url} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
      { props.hasQuestions && !visible &&
        <div className="video-questions">
        {props.setClosebuttonstate(true)}
          { props.questions.map( (question, questionIndex) => 
          questionIndex==singlequestionIndex &&
          <div className={`question-group`} key={`question-group-${questionIndex}`}>
            <p className="question-text">{question.questionText}</p>
              <div className="question-options">
                { question.options.map( (option, optionIndex) => 
                  <Fragment key={`question-${questionIndex}-option-${optionIndex}`}>
                      <div className={`question-option${optionsSelected[questionIndex].value === optionIndex ? ' selected' : ''}`}>
                          <div className="label" onClick={ () => { updateItem(questionIndex, 'value', optionIndex); } }>{option.text}</div>
                      </div>
                  </Fragment>
                ) }
              </div>
            { optionsSelected[questionIndex].value !== "" &&
             <StyledContainer variant='light_blue' className='feedback'>
                  <div className='feedback-text' dangerouslySetInnerHTML={{ __html: validateAnswer(questionIndex) ? question.successMessage : question.errorMessage}}></div>
                  <div className="feedback-button-row">
                    <button className="next-button global-button"  onClick={()=>handleNextClick(questionIndex)}>Next</button>
                  </div>
              </StyledContainer>
              // <div className="feedback" dangerouslySetInnerHTML={{ __html: validateAnswer(questionIndex) ? question.successMessage : question.errorMessage }}>
              // </div> 
            }
            {/* {optionsSelected[questionIndex].value !== "" && questionIndex<props.questions.length-1&&<button className="next-button global-button" onClick={()=>handleNextClick()}>Next</button>}
            {optionsSelected[questionIndex].value !== "" && questionIndex==props.questions.length-1&&<button className="next-button global-button" onClick={()=>props.onAnswered()}>Done</button>} */}
          </div>
        ) }
        </div>
      }
   </div>
  );

}

export default VideoWrapper;